import axios from "axios";
import routes from "../../configs/api";
import getCouponAuthHeaders from "./couponAuthHeaders";

const createCoupon = (payload) => {
  return new Promise((resolve, reject) => {
    let headers;

    try {
      headers = getCouponAuthHeaders();
    } catch (error) {
      reject(error);
      return;
    }

    axios
      .post(routes.CREATE_COUPON, payload, {
        headers,
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export default createCoupon;
